export function backspaceKey(event) {
  event.preventDefault()

  if (!this.selectedItem) return
  const { selectedItem } = this

  const params = selectedItem.getParams()
  let { text, cursorPosition } = params

  if (cursorPosition === 0) return

  let deletedCharNumber = 1
  if (cursorPosition > 1 && text.slice(cursorPosition - 2, cursorPosition) === '/n')
    deletedCharNumber = 2

  text = text.slice(0, cursorPosition - deletedCharNumber) + text.slice(cursorPosition)
  cursorPosition -= deletedCharNumber

  selectedItem.setParams({ text, cursorPosition })

  this.engine.reRender()
}



// WEBPACK FOOTER //
// ./src/components/ScreenshotEditor/keyboardActions/backspaceKey.js